/**
 * Created by zqy on 2018/8/20 0020.
 */
import Cookies from 'js-cookie'
import { saveToLocal,loadFromLocal,removeFromLocal} from './localStorage' // getToken from cookie

//存储token
const TokenKey = 'Admin-Token-Meitui'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}
//存储登录账号
const LoginInfoKey = 'Admin-Login-Meitui'
export function getLoginInfo() {
  let info=Cookies.get(LoginInfoKey)
  try{
    return JSON.parse(info)
  }
  catch (err){
    return info
  }
}

export function setLoginInfo(token) {
  return Cookies.set(LoginInfoKey, token)
}

export function removeLoginInfo() {
  return Cookies.remove(LoginInfoKey)
}

//存储列表搜索的数据
const searchKey = 'Admin-Search-Meitui'
export function setSearchList(value){
  saveToLocal(searchKey, value)
}
export function getSearchList() {
  return loadFromLocal(searchKey)
}
export function removeSearchList() {
  removeFromLocal(searchKey)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js